import { Component, ViewChild } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { Djelatnost_firme, ApiClientService } from '../../services/api-client.service';

@Component({
  selector: 'app-djelatnosti-firme',
  templateUrl: './djelatnosti-firme.component.html',
  styleUrls: ['./djelatnosti-firme.component.scss']
})
export class DjelatnostiFirmeComponent {
  @ViewChild('djelatnostiGrid', { static: false }) djelatnostiGrid: any;

  gridData: Djelatnost_firme[] = [];
  loading = false;
  isCreatePopupVisible = false;
  loadPanelPosition = { of: '#djelatnostiGrid' };

  djelatnostForm!: FormGroup;

  constructor(
    private apiClient: ApiClientService,
    private fb: FormBuilder
  ) {
    this.initializeForm();
  }

  ngOnInit() {
    this.loadDjelatnosti();
  }

  initializeForm() {
    this.djelatnostForm = this.fb.group({
      djelatnost: ['', Validators.required]
    });
  }

  async loadDjelatnosti() {
    this.loading = true;
    try {
      this.gridData = await this.apiClient.djelatnostiFirmeAll();
    } catch (error) {
      console.error('Error loading djelatnosti:', error);
    } finally {
      this.loading = false;
    }
  }

  onAddClick() {
    this.djelatnostForm.reset();
    this.isCreatePopupVisible = true;
  }

  async createDjelatnost() {
    if (this.djelatnostForm.valid) {
      this.loading = true;
      try {
        const formData = this.djelatnostForm.value;
        await this.apiClient.djelatnostiFirmePOST(formData);
        this.isCreatePopupVisible = false;
        this.djelatnostForm.reset();
        this.loadDjelatnosti(); // Refresh grid
      } catch (error) {
        console.error('Error creating djelatnost:', error);
      } finally {
        this.loading = false;
      }
    }
  }

  onRefreshClick() {
    this.loadDjelatnosti();
  }

  onCreatePopupHidden() {
    this.isCreatePopupVisible = false;
  }
}
